import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react';

import BadgeReport from 'badge/BadgeReport';
import CustomerPaidShippingRating from 'client/CustomerPaidShippingRating';
import { PublicCompanyProvider } from 'client/hooks';
import ClientPortal from 'client/portal/ClientPortal';
import ClientShippingPortal from 'client/portal/ClientShippingPortal';
import ShippingRating from 'client/ShippingRating';
import TicketDetail from 'client/TicketDetail';
import TicketRate from 'client/TicketRate';
import TicketUnsubscribe from 'client/TicketUnsubscribe';
import TrackNTrace from 'client/TrackNTrace';
import { ErrorBoundary } from 'components/errorBoundaries';
import ScrollToTop from 'components/ScrollToTop';
import ClientLayout from 'layouts/ClientLayout';
import { PublicApiProvider } from 'public-api';
import clientRoutes from 'routes/codegen/clientRoutes';
import { ToastContainer } from 'ui';
import ToastStore, { ToastStoreContext } from 'ui/toast/ToastStore';

const Retino = observer(() => {
  const [toastStore] = useState(new ToastStore());

  useEffect(() => {
    window.appState.toastStore = toastStore;
  }, []);

  return (
    <ToastStoreContext.Provider value={toastStore}>
      <ScrollToTop />

      <PublicCompanyProvider>
        <Routes>
          <Route element={<ClientLayout />}>
            <Route path={clientRoutes.ticketTicketIdUnsubscribeHashcode.url} element={<TicketUnsubscribe />} />
            <Route path={clientRoutes.ticketTicketIdRatingRatingCommentDetail.url} element={<TicketRate />} />
            <Route path={clientRoutes.ticketTicketDetail.url} element={<TicketDetail />} />
            <Route path={clientRoutes.transportShippingIdRatingRating.url} element={<CustomerPaidShippingRating />} />
            <Route path={clientRoutes.shippingShippingIdRatingRating.url} element={<ShippingRating />} />
          </Route>

          <Route path="/:lang/client/:companyId/badge/report/" element={<BadgeReport />} />

          <Route element={<ClientLayout hideFooter />}>
            <Route path={clientRoutes.portal.url} element={<ClientPortal />} />
            <Route path={clientRoutes.shippingPortal.url} element={<ClientShippingPortal />} />
          </Route>

          <Route element={<ClientLayout hideFooter gray={false} />}>
            <Route path={clientRoutes.trackAndTracePageDetail.url} element={<TrackNTrace />} />
          </Route>
        </Routes>
      </PublicCompanyProvider>

      <ToastContainer />
    </ToastStoreContext.Provider>
  );
});

const container = document.getElementById('react-root');
const root = createRoot(container!);
root.render(
  <BrowserRouter>
    <ErrorBoundary>
      <PublicApiProvider>
        <Retino />
      </PublicApiProvider>
    </ErrorBoundary>
  </BrowserRouter>,
);
